const getStatus = (reserveDate, returnDate, repair, damage) => {
    const today = new Date();
    if(repair){
        return "수리중"
    } else if(damage){
        return "파손"
    } else if(!repair && !damage){
        if(returnDate === null || new Date(returnDate).getTime() < today.getTime()){
            return "대여가능"
        } else if(new Date(reserveDate).getTime() > today.getTime()){
            return "예약중"
        } else {
            return "대여중"
        }
    }
}

export default getStatus;